import styled from 'styled-components'

interface ContainerProps {
  hideBorderTop?: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-top: ${({ hideBorderTop }) => hideBorderTop ? 'none' : '1px solid #E2E2E2'};
`

export const ReservationInfoWrapper = styled.div`
  display: flex;
`